/// <reference path="TestGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class TestPickerGrid extends TestGrid {

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 50;
            return opt;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        private _criteria: any[];

        set criteria(value: any[]) {
            if (this._criteria != value) {
                this._criteria = value;
            }
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            if (this._criteria != null)
                request.Criteria = Serenity.Criteria.and(request.Criteria, this._criteria);

            return true;
        }
    }
}